export default "__VITE_ASSET__DvQ4orMB__"